import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
    
import { DeliveryForFee } from '../../interfaces/deliveryforfee.interface';
import { DeliveryForFeeService } from "../../services/deliveryforfee";
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { Router } from '@angular/router';
import { WarehousecodeService } from '../../services/warehousecode';
import { WarehouseCode } from '../../interfaces/warehousecode.interface';
import { Product } from '../../interfaces/product.interface';
import { ProductcodeService } from "../../services/productcode";
import { CustomerCode } from '../../interfaces/customercode.interface';
import { CustomerCodeService } from '../../services/customercode';

@Component({
  selector: 'app-add-deliveryforfee',
  imports: [ReactiveFormsModule],
  templateUrl: './add-deliveryforfee.html',
  styleUrl: './add-deliveryforfee.css'
})

export class AddDeliveryForFeeComponent implements OnInit {

  myForm: FormGroup;
  deliveryforfees: DeliveryForFee[] = [];
  products: Product[] = [];
  warehousecodes: WarehouseCode[] = [];
  customercodes: CustomerCode[] = [];


constructor(
              private deliveryforfeeService: DeliveryForFeeService,
              private customercodeService: CustomerCodeService,
              private productService: ProductcodeService,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder,
            private warehousecodeService: WarehousecodeService) 
              {
                this.myForm = this.fb.group({
                  productcode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  returndocno: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  returndate: new FormControl('',[Validators.required,Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  warehousecode: new FormControl('',[Validators.required,Validators.maxLength(10)]),
                  dffvolume: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  volumeid: new FormControl('',[Validators.required,Validators.maxLength(1)]),
                  lineno: new FormControl('',[Validators.required,Validators.pattern('[0-9]*$')]),
                  customercode: new FormControl('',[Validators.maxLength(30)]),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }

  async ngOnInit(): Promise<void>
 {

    try 
    {
      this.products = await this.productService.getProductcodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getproducts in deliveryforfee',error);
    }

    try 
    {
      this.warehousecodes = await this.warehousecodeService.getWarehousecodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getwarehousecodes in deliveryforfee',error);
    }

     try 
    {
      this.customercodes = await this.customercodeService.getCustomercodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getcustomercodes in deliveryforfee',error);
    }
  }

  get productcode() {
    return this.myForm.get('productcode');
  }
   get warehousecode() {
    return this.myForm.get('warehousecode');
  }
  get returndocno() {
    return this.myForm.get('returndocno');
  }
  get returndate() {
    return this.myForm.get('returndate');
  }
  get dffvolume() {
    return this.myForm.get('dffvolume');
  }
  
  get volumeid() {
    return this.myForm.get('volumeid');
  }
 get lineno() {
    return this.myForm.get('lineno');
  }
   get customercode() {
    return this.myForm.get('customercode');
  }
  get uploaded() {
    return this.myForm.get('uploaded');
  }

  async addDeliveryForFee(): Promise<void>
  {

    var productcode = this.myForm.value.productcode != null ? this.myForm.value.productcode.trim() : "";
    var warehousecode = this.myForm.value.warehousecode != null ? this.myForm.value.warehousecode.trim() : "";
    var returndocno = this.myForm.value.returndocno != null ? this.myForm.value.returndocno.trim() : "";
    var returndate = this.myForm.value.returndate != null ? this.myForm.value.returndate.trim() : "";
    var dffvolume = this.myForm.value.dffvolume != null ? this.myForm.value.dffvolume : 0;
    var volumeid = this.myForm.value.volumeid != null ? this.myForm.value.volumeid.trim() : "";
    var lineno = this.myForm.value.lineno != null ? this.myForm.value.lineno : 0;
    var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";
    var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.deliveryforfeeService.create(productcode,returndocno,returndate,warehousecode,dffvolume,volumeid,lineno,customercode,uploaded);
          this.cdr.detectChanges();
          this.router.navigateByUrl('delivery'); 
        } catch (error) {
          console.error('createDeliveryForFee error',error);
        }

  }   

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('delivery');
  }

}
